<template>
  <div class="video-wrap">
    <VResponsive :aspect-ratio="16/9">
      <ClientOnly>
        <VideoPlayer v-model="currentTime" :video-url="interview.video.url" />
      </ClientOnly>
    </VResponsive>
  </div>
</template>

<script>
import ClientOnly from 'vue-client-only';
import VideoPlayer from '@huntica/huntica-interview-module/src/components/VideoPlayer.vue';

export default {
  name: 'CandidateInterviewOffice',
  components: { ClientOnly, VideoPlayer },
  model: {
    prop: 'time',
    event: 'input',
  },
  props: {
    time: {
      type: Number,
      required: true,
    },
    interview: {
      type: Object,
      required: true,
    },
  },
  computed: {
    currentTime: {
      get() {
        return this.time;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.video-wrap {
  padding: 0.625rem;
  background-color: #f5f5f5;
  border-radius: 0 0 0.5rem 0.5rem;
}
@media (max-width: 959px) {
  .video-wrap {
    padding: 0;
  }
}
</style>
